module.exports = __webpack_public_path__ + "static/media/Receivership Order Dated October 19, 2023.f0271af9.pdf";